import type { SelectHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: Array<{ label: string; value: string }>;
  helperText?: string;
}

export function Select({
  label,
  options,
  helperText,
  className,
  id,
  ...props
}: SelectProps) {
  const selectId = id ?? props.name ?? label;

  return (
    <label className="flex flex-col gap-2 text-sm text-mist" htmlFor={selectId}>
      <span className="font-medium uppercase tracking-[0.14em] text-parchment/90">
        {label}
      </span>
      <select
        id={selectId}
        className={cn(
          "rounded-2xl border border-gold/20 bg-black/20 px-4 py-3 text-parchment outline-none transition focus:border-gold/55 focus:bg-black/30",
          className,
        )}
        {...props}
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            className="bg-midnight text-parchment"
          >
            {option.label}
          </option>
        ))}
      </select>
      {helperText && <span className="text-xs text-mist/80">{helperText}</span>}
    </label>
  );
}
